import { useConsumerById } from '../consumer';
import { useEmployerStaff } from '../employerStaff';
import { usePeoPayrollProviderStaff } from '../peoPayrollProviderStaff';
import { usePeoStaff } from '../peoStaff';
import { usePlatformStaff } from '../platformStaff';
import { useVerifierStaff } from '../verifierStaff';

import { useCurrentUser } from './useCurrentUser';

export const useCurrentUserStaff = () => {
  const { user, isUserLoading } = useCurrentUser();

  const { platformStaff, loading: isPlatformStaffLoading } = usePlatformStaff(
    user?.platformStaff?.id,
  );

  const { verifierStaff, loading: isVerifierStaffLoading } = useVerifierStaff(
    user?.verifierStaff?.id,
  );

  const { peoPayrollProviderStaff, loading: isPeoPayrollProviderStaffLoading } =
    usePeoPayrollProviderStaff(user?.peoPayrollProviderStaff?.id);

  const { peoStaff, loading: isPeoStaffLoading } = usePeoStaff(user?.peoStaff?.id);

  const { employerStaff, loading: isEmployerStaffLoading } = useEmployerStaff(
    user?.employerStaff?.id,
  );

  const { consumer: employee, loading: isEmployeeLoading } = useConsumerById(user?.employee?.id);

  const loading =
    isUserLoading ||
    isPlatformStaffLoading ||
    isVerifierStaffLoading ||
    isPeoPayrollProviderStaffLoading ||
    isPeoStaffLoading ||
    isEmployerStaffLoading ||
    isEmployeeLoading;

  return {
    platformStaff,
    verifierStaff,
    peoPayrollProviderStaff,
    peoStaff,
    employerStaff,
    employee,
    loading,
  };
};
